import AdminCenterUsers from '../components/AdminCenterUsers';

export default function AdminUsers() {
  return (
    <>
      <AdminCenterUsers />
    </>
  );
}
